var render = function render(){var _vm=this,_c=_vm._self._c;return _c('download-excel',{staticClass:"btn btn-primary",attrs:{"fetch":_vm.fetchData,"data":_vm.data,"fields":_vm.fields,"meta":_vm.meta,"name":_vm.name,"header":_vm.title,"type":"csv","escapeCsv":true}},[_c('label',{staticClass:"download-csv",staticStyle:{"cursor":"pointer"}},[_vm._v("CSV")])])
}
var staticRenderFns = []

export { render, staticRenderFns }